<template>
    <b-modal :title="title" ref="modal" id="generic-modal" centered no-close-on-backdrop @hide="hide">
        <div class="mb-3">
            <p>
                {{ description }}
            </p>
            <ul class="pl-4 mt-2" v-if="items !== undefined">
                <li class="text-white" v-for="(item, index) in items" :key="index">{{ item }}</li>
            </ul>
        </div>
        <youtube v-if="video" ref="youtube-player" :video-id="getVideoId()" width="100%" height="264px" @playing="playedVideo"></youtube>

        <template v-slot:modal-footer>
            <ci-button v-if="showCancel" type="gray" :disabled="loading" @click="onCancel" :text="cancelButtonText" />
            <ci-button type="primary" block :loading="loading" @click="onContinue" :text="confirmButtontext" />
        </template>
    </b-modal>
</template>
<script>
export default {
    name: 'GenericModal',
    props: {
        loading: Boolean,
        showCancel: {
            type: Boolean,
            default: false,
        },
        items: Array,
        description: String,
        video: String,
        title: String,
        confirmButtontext: String,
        cancelButtonText: {
            type: String,
            default: 'cancelar',
        },
    },
    data() {
        return {
            played: false,
        }
    },
    methods: {
        show() {
            this.$refs['modal'].show()
            window.Intercom('trackEvent', 'obra-demo-popup-view')
        },
        hide() {
            this.checkVideoCompletion()
            this.$refs['modal'].hide()
        },
        onContinue() {
            this.checkVideoCompletion()
            this.$emit('onContinue')
        },
        async checkVideoCompletion() {
            if (!this.video) return

            let totalTime = await this.$refs['youtube-player'].player.getDuration()
            let currentTime = await this.$refs['youtube-player'].player.getCurrentTime()
            if (currentTime / totalTime >= 0.5) {
                window.Intercom('trackEvent', 'obra-demo-video-view-complete')
            }
        },
        playedVideo() {
            if (!this.played) {
                this.played = true
                window.Intercom('trackEvent', 'obra-demo-video-view')
            }
        },
        getVideoId() {
            return this.$youtube.getIdFromUrl(this.video)
        },
    },
}
</script>
<style scoped>
ul li {
    list-style-position: outside;
    list-style: none;
    margin-top: 10px;
}
li::before {
    content: '•';
    color: #1eb3fd;
    margin-left: -1em;
    width: 1em;
    display: inline-block;
}
</style>
